import { uid, ZERO_PADDING, ZERO_RADIUS } from "../create-shared";
import { DEFAULT_IMAGE_OVERLAY } from "../image-overlay";
import type { ImageBlock } from "../types";
import type { BlockDefinition } from "./types";

export function createImageBlock(): ImageBlock {
  return {
    id: uid(),
    type: 'image',
    media: null,
    alt: '',
    href: '',
    align: 'center',
    widthPx: null,
    heightMode: 'auto',
    heightPx: null,
    objectFit: 'cover',
    intrinsicSize: null,
    borderRadius: { ...ZERO_RADIUS },
    fullWidthMobile: false,
    imageOverlay: { ...DEFAULT_IMAGE_OVERLAY },
    padding: { ...ZERO_PADDING },
  };
}

export const imageBlockDefinition: BlockDefinition = {
  type: 'image',
  label: 'Image',
  create: createImageBlock,
};
